import ResponsiveSidebar from "../../General/ResponsiveSidebar/ResponsiveSidebar";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  Warehouse as WarehouseIcon,
  Group as GroupIcon,
  FactCheck as FactCheckIcon,
  HomeWork as HomeWorkIcon,
  ReceiptLong as ReceiptLongIcon,
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  Receipt as ReceiptIcon,
  Assessment as AssessmentIcon,
  ShowChart as ShowChartIcon,
} from "@mui/icons-material";
import { Link as RouterLink, useLocation } from "react-router-dom";

const drawerWidth = 240;
const collapsedWidth = 60;

interface RentalSidebarProps {
  open?: boolean;
  toggle?: () => void;
}

const RentalSidebar = ({
  open = false,
  toggle = () => {},
}: RentalSidebarProps) => {
  const location = useLocation();

  const rentalMenuItems = [
    { text: "Dashboard", icon: <DashboardIcon />, path: "/rental" },
    { text: "Companies", icon: <WarehouseIcon />, path: "/rental/companies" },
    { text: "Customers", icon: <GroupIcon />, path: "/rental/customers" },
    { text: "Compliance", icon: <FactCheckIcon />, path: "/rental/compliance" },
    { text: "Rents", icon: <HomeWorkIcon />, path: "/rental/rents" },
    { text: "Invoices", icon: <ReceiptIcon />, path: "/rental/invoices" },
    {
      text: "Rent Payments",
      icon: <ReceiptLongIcon />,
      path: "/rental/rentPayments",
    },
    { text: "Reports", icon: <AssessmentIcon />, path: "/rental/reports" },
    {
      text: "Profitability Forecast",
      icon: <ShowChartIcon />,
      path: "/rental/profitability-forecast",
    },
  ];

  const isSelected = (path: string) => location.pathname.startsWith(path);

  return (
    <ResponsiveSidebar
      open={open}
      onClose={toggle}
      sx={(theme) => ({
        width: open ? drawerWidth : collapsedWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? drawerWidth : collapsedWidth,
          boxSizing: "border-box",
          top: 64,
          height: "calc(100% - 64px)",
          overflowX: "hidden",
          position: "fixed",
          transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.standard,
          }),
        },
      })}
    >
      <Toolbar sx={{ justifyContent: open ? "flex-end" : "center" }}>
        <IconButton
          onClick={toggle}
          aria-label={
            open ? "Close section navigation" : "Open section navigation"
          }
        >
          {open ? <ChevronLeftIcon /> : <MenuIcon />}
        </IconButton>
      </Toolbar>
      <List>
        {rentalMenuItems.map((item) => {
          const selected =
            item.path === "/rental"
              ? location.pathname === "/rental"
              : isSelected(item.path);

          const button = (
            <ListItemButton
              key={item.text}
              selected={selected}
              component={RouterLink}
              to={item.path}
              sx={{ justifyContent: open ? "initial" : "center" }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 0,
                  justifyContent: "center",
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          );

          return open ? (
            button
          ) : (
            <Tooltip key={item.text} title={item.text} placement="right">
              {button}
            </Tooltip>
          );
        })}
      </List>
    </ResponsiveSidebar>
  );
};

export default RentalSidebar;
